import CalendarComponent from '../../calendar/Calendar'

const Calendar = () => {
  return <CalendarComponent />
}

export default Calendar
